export default {
  info: "个人信息",
  signature: "个人签名",
  dataSetting: "个人资料设置",
  logOut: "退出登录",
  account: "账号",
  oldPassword: "当前密码",
  newPassword: "新密码",
  confirmPassword: "重新输入一次密码",
  passwordsNotMatch: "密码不一致",
};
